import { useEffect, useState } from "react"
import { getDesktopBridge } from "@/lib/desktop"
import {
  applyMediaCacheProgress,
  isMediaCacheProgress,
  mediaCacheChipPercent,
  mediaCacheChipVisible,
  type MediaCacheProgress,
} from "@/lib/media-cache-progress"

export function useMediaCacheDownloads(): { visible: boolean; percent: number | null } {
  const [items, setItems] = useState<ReadonlyMap<string, MediaCacheProgress>>(() => new Map())

  useEffect(() => {
    const desktop = getDesktopBridge()
    if (!desktop?.subscribeMediaCacheProgress) return

    let cancelled = false
    void desktop
      .mediaCacheSnapshot?.()
      .then((rows) => {
        if (cancelled || !Array.isArray(rows)) return
        const next = new Map<string, MediaCacheProgress>()
        for (const row of rows) {
          if (isMediaCacheProgress(row) && (row.state === "queued" || row.state === "active")) next.set(row.key, row)
        }
        setItems(next)
      })
      .catch(() => {
        // Snapshot is best-effort; live events still update the chip.
      })

    const unsubscribe = desktop.subscribeMediaCacheProgress((event) => {
      if (!isMediaCacheProgress(event)) return
      setItems((prev) => applyMediaCacheProgress(prev, event))
    })

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  return {
    visible: mediaCacheChipVisible(items.values()),
    percent: mediaCacheChipPercent(items.values()),
  }
}
